import { ReportsSegmentDatasource } from "data/datasources/reports-segment-datasource";
import {makeAuthorizeHttpClientDecorator} from "../decorators/authorize-http-client-decorator-factory";

export const makeReportsSegmentDatasource = () => new ReportsSegmentDatasource(makeAuthorizeHttpClientDecorator())
